'use client'

import dynamic from 'next/dynamic'
import { Box, Grid, Typography } from '@mui/material'

// Types
import type { CareersFormProps } from '@/types/components/organisms/forms/careers'

// Components
import TurnstileFieldMolecule from '@/components/molecules/field/turnstile'

const TextFieldMolecule = dynamic(() => import('@/components/molecules/field/text'))
const PrimaryButtonAtom = dynamic(() => import('@/components/atoms/button/primary'))

// Application form: contact, the role, an optional link to the CV, and a short note
const CareersFormOrganism = (props: CareersFormProps) => {
	// Props
	const { lng, locale, control, loading, turnstileRef, onSubmit } = props

	// Variables
	const { fields, submit, requiredNote } = locale.content.careers.form
	const text = { lng, locale, control, size: 'small' as const }

	return (
		<Grid
			component="form"
			container
			spacing={1.5}
			onSubmit={event => {
				event.preventDefault()
				onSubmit()
			}}
			noValidate
		>
			<Grid size={{ xs: 12, sm: 6 }}>
				<TextFieldMolecule {...text} name="full_name" label={fields.fullName} required />
			</Grid>

			<Grid size={{ xs: 12, sm: 6 }}>
				<TextFieldMolecule {...text} name="mobile" type="mobile" pattern="mobile" label={fields.mobile} helperText={fields.mobileHelper} required />
			</Grid>

			<Grid size={{ xs: 12, sm: 6 }}>
				<TextFieldMolecule {...text} name="email" type="email" pattern="email" label={fields.email} helperText={fields.emailHelper} required />
			</Grid>

			<Grid size={{ xs: 12, sm: 6 }}>
				<TextFieldMolecule {...text} name="position" label={fields.position} helperText={fields.positionHelper} required />
			</Grid>

			<Grid size={12}>
				<TextFieldMolecule {...text} name="resume_url" label={fields.resume} helperText={fields.resumeHelper} />
			</Grid>

			<Grid size={12}>
				<TextFieldMolecule {...text} name="message" label={fields.message} multiline rows={4} required />
			</Grid>

			<Grid size={12} sx={{ mt: 0.5 }}>
				<TurnstileFieldMolecule ref={turnstileRef} lng={lng} action="careers" />
			</Grid>

			<Grid size={12} sx={{ mt: 0.5 }}>
				<Box sx={{ '& .MuiButtonBase-root': { width: 1 } }}>
					<PrimaryButtonAtom text={submit} type="submit" color="primary" size="medium" loading={loading} />
				</Box>

				<Typography sx={{ mt: 1, fontSize: 12.5, color: 'text.secondary', textAlign: 'center' }}>{requiredNote}</Typography>
			</Grid>
		</Grid>
	)
}

export default CareersFormOrganism
